<template>
  <div id="app">
    <router-view v-if="$route.name == 'Login'"> </router-view>
    <el-container v-else>
      <!-- 顶部导航栏 -->
      <el-header>
        <TopNav />
      </el-header>
      <el-container style="max-height: calc(100% - 80px)">
        <!-- 侧边导航栏 -->
        <el-aside :style="{ width: pageWidth < 768 ? '64px' : '300px' }">
          <SideNav />
        </el-aside>
        <el-main>
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"> </router-view>
          </keep-alive>  v-if="!$route.meta.keepAlive"-->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav";
import TopNav from "@/components/TopNav"; 
export default {
  name: "App",
  components: {
    SideNav,
    TopNav,
  },
  data() {
    return {
      pageWidth: document.documentElement.clientWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.pageWidth = document.documentElement.clientWidth;
    });
  }, 
};
</script>

<style>
html,
body,
#app,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}
::-webkit-scrollbar {
  width: 0;
}
.el-header {
  padding: 0 !important;
  height: 80px !important;
}
.el-aside {
  height: 100%;
}
.el-menu {
  border-right-width: 0 !important;
}

/* html{
  padding: 0px;
  margin: 0px;
}*/
</style>
